import { render, staticRenderFns } from "./Relation.vue?vue&type=template&id=08eb7ad2"
import script from "./Relation.vue?vue&type=script&setup=true&lang=js"
export * from "./Relation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports